/**
 * Grid layout constants for ReportLanding components
 */

export const TOTAL_COLUMNS = 12;
export const GRID_GAP = 12;
export const WIDGET_MAX_HEIGHT = 500;
export const MAX_WIDGETS_PER_ROW = 3;

// Public-share snapshots only capture the first N rows of list widgets (AnnotationExplorer,
// ResponsesList) — keeps the snapshot inside Mongo's doc limit. See SHARED_REPORTS_DESIGN.md.
export const SNAPSHOT_LIST_WIDGET_CAP = 20;
